var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { staticClass: "pa-0", attrs: { fluid: "" } },
    [
      _c("EditLocationNameDialog", { ref: "editLocationNameDialog" }),
      _vm._v(" "),
      _c(
        "v-card",
        [
          _c(
            "v-layout",
            { staticClass: "align-baseline" },
            [
              _c(
                "div",
                {
                  staticClass: "key-content font-weight-medium pl-3 pr-1 py-2",
                },
                [_vm._v("\n        Location Name\n      ")]
              ),
              _vm._v(" "),
              _c("v-flex", { staticClass: "grey--text text--darken-3" }, [
                _vm._v("\n        " + _vm._s(_vm.displayName) + "\n      "),
              ]),
              _vm._v(" "),
              _c("v-spacer"),
              _vm._v(" "),
              _vm.editForm
                ? _c(
                    "div",
                    { staticClass: "action-content" },
                    [
                      _c(
                        "v-tooltip",
                        {
                          attrs: { "open-delay": 500, right: "" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function ({ on }) {
                                  return [
                                    _c(
                                      "v-btn",
                                      _vm._g(
                                        {
                                          attrs: { icon: "" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.editMFDisplayName()
                                            },
                                          },
                                        },
                                        on
                                      ),
                                      [
                                        _c(
                                          "v-icon",
                                          { attrs: { color: "warning" } },
                                          [_vm._v("edit")]
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            73713860
                          ),
                        },
                        [
                          _vm._v(" "),
                          _c("span", [_vm._v(_vm._s(_vm.$t("Button.Edit")))]),
                        ]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-layout",
            { staticClass: "align-baseline" },
            [
              _c(
                "div",
                {
                  staticClass: "key-content font-weight-medium pl-3 pr-1 py-2",
                },
                [_vm._v("\n        Data Types\n      ")]
              ),
              _vm._v(" "),
              _c(
                "v-flex",
                { staticClass: "grey--text text--darken-3" },
                [
                  _vm._l(_vm.dataTypes, function (dataType, index) {
                    return _c(
                      "v-chip",
                      { key: `dataType-${index}`, attrs: { small: "" } },
                      [_vm._v("\n          " + _vm._s(dataType) + "\n        ")]
                    )
                  }),
                  _vm._v(" "),
                  _vm.dataTypes.length === 0
                    ? _c(
                        "v-chip",
                        {
                          attrs: {
                            outline: "",
                            color: "error",
                            label: "",
                            small: "",
                          },
                        },
                        [_vm._v("\n          No data types\n        ")]
                      )
                    : _vm._e(),
                ],
                2
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }